var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import classnames from 'classnames';
import union from 'lodash/union';
import without from 'lodash/without';
import { PureComponent } from 'react';
import { change } from 'redux-form';
import styles from './categorizedMultiSelectCategory.module.scss';
import { CategorizedMultiSelectCategoryItem } from './categorizedMultiSelectCategoryItem';
export class CategorizedMultiSelectCategory extends PureComponent {
    getPossibleValues() {
        return this.props.category.items.map((item) => item.value);
    }
    getCheckedCategoryValues() {
        const pValues = this.getPossibleValues();
        return this.props.input.value.filter((value) => pValues.indexOf(value) !== -1);
    }
    isIndeterminate() {
        const values = this.getCheckedCategoryValues();
        const pValues = this.getPossibleValues();
        return values.length > 0 && values.length < pValues.length;
    }
    isChecked() {
        const values = this.getCheckedCategoryValues();
        const pValues = this.getPossibleValues();
        return values.length === pValues.length;
    }
    selectCategory() {
        const { meta, input, readOnly } = this.props;
        if (readOnly)
            return;
        const { form: formName, dispatch } = meta;
        const { name, value } = input;
        const shouldUncheck = this.getCheckedCategoryValues().length > 0;
        const newValue = shouldUncheck
            ? without(value, ...this.getPossibleValues())
            : union(value, this.getPossibleValues());
        dispatch(change(formName, name, newValue));
    }
    render() {
        const _a = this.props, { category, readOnly } = _a, otherProps = __rest(_a, ["category", "readOnly"]);
        const rootClass = classnames({
            [styles.root]: styles.root,
            [styles.rootDisabled]: category.disabled,
            [styles.rootReadOnly]: readOnly,
        });
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [_jsxs("label", Object.assign({ className: styles.name }, { children: [_jsx(Checkbox, { checked: this.isChecked(), name: category.categoryName, id: category.categoryName, indeterminate: this.isIndeterminate(), onChange: this.selectCategory, className: styles.checkbox, disabled: category.disabled }), category.categoryName] })), _jsx("div", { children: category.items.map((item) => (_jsx(CategorizedMultiSelectCategoryItem, Object.assign({ readOnly: readOnly }, otherProps, { item: item, disabled: category.disabled }), item.name))) })] })));
    }
}
__decorate([
    boundMethod
], CategorizedMultiSelectCategory.prototype, "selectCategory", null);
